import client from "./client";

const COMMUNICATIONS_BASE_PATH = "/api/v1/communications";

export async function listCommunicationResults({
  task_id,
  page = 1,
  page_size = 50,
  search,
  risk_id,
  status,
  type,
  product_type,
  has_risks,
} = {}) {
  const res = await client.get(`${COMMUNICATIONS_BASE_PATH}/${task_id}/results`, {
    params: {
      page,
      page_size,
      search,
      risk_id,
      status,
      type,
      product_type,
      has_risks,
    },
  });
  return res.data;
}

export async function getCommunicationStats(taskId) {
  const res = await client.get(`${COMMUNICATIONS_BASE_PATH}/${taskId}/stats`);
  return res.data;
}

export async function getCommunicationDetail(communicationId) {
  const res = await client.get(`${COMMUNICATIONS_BASE_PATH}/items/${communicationId}`);
  return res.data;
}

export async function getAnalyticsOverview() {
  const res = await client.get(`${COMMUNICATIONS_BASE_PATH}/analytics/overview`);
  return res.data;
}
